import {DocumentationEntryForManipulationDto} from 'app/_models/model/documentationEntryForManipulationDto';
import {IEntryForManipulation} from '../_interface/ientry-for-manipulation';
import {DocumentationEntryFieldForShowDto} from 'app/_models/model/documentationEntryFieldForShowDto';
import {IEntryFieldForManipulation} from '../_interface/ientry-field-for-manipulation';
import {IFullTemplateField, IGenericContentField} from '../_interface/itemplate-field';
import {keyValueToObject} from './itemFromKeyValue.fn';
import {IEntryFieldForShow} from '../_interface/ientry-field-for-show';

export const convertEntryForEdit = (input: DocumentationEntryForManipulationDto, ftf: IFullTemplateField[] = []): IEntryForManipulation => {
	const templateFieldsForInput = input.fields.map(f => ftf.find(tf => f.templateFieldId === tf.templateFieldId));
	const fieldsWithFieldType = input.fields.map((cv, index) => {
		if (!templateFieldsForInput[index]) return cv;
		// return {...cv, fieldType: templateFieldsForInput[index].fieldType};
		return {...cv, fieldType: templateFieldsForInput[index].fieldType};
	});
	return ({
		...input,
		fields: convertEntryFieldsForManipulation(fieldsWithFieldType)
	});
};

const getLatest = (item: DocumentationEntryFieldForShowDto) => {
	// need to add by date instead of index
	const newItem = {...item, content: [...item.content]};
	newItem.content.sort((a, b) => a.modificationDate > b.modificationDate ? 1 : -1);
	return newItem.content[newItem.content.length - 1];
};

export const convertEntryFieldsForManipulation = (
	kv: DocumentationEntryFieldForShowDto[],
	): IEntryFieldForManipulation[] => {
	return [...kv].map((item) => {
		return {
			...item,
			content: keyValueToObject(getLatest(item).body, item.fieldType) as IGenericContentField,
			history: item.content
		};
	});
};

export const convertEntryFieldFromShowToManipulation = (field: IEntryFieldForShow): IEntryFieldForManipulation => {
	return {
		...field,
		content: field.content.lastEntry
	};
};
